// extracted by mini-css-extract-plugin
export default {"inputBox":"DriveThruContentHeader_inputBox__pPr+h","sameRow":"DriveThruContentHeader_sameRow__37m06"};